<template>
    <div>
        <div class="gray_line">
            <div class="gray_inner">
                <div class="item active">Проекты</div>
            </div>
        </div>
        <div class="request_content">
            <Spin v-if="isLoading"></Spin>
            <template v-else>

                <div class="filter_search_form" style="margin: 30px 0 0 0">
                    <div class="filters_block_wrapper">
                        <div class="switchers__wrapper">
														<div class="field__wrapper">
                                <p class="field_label">Тип проекта</p>
                                <Select
                                        v-model:value="project_type"
                                        :options="project_types"
                                        :allowClear="true"
                                        size="middle"
                                        style="width: 200px"
                                ></Select>
														</div>
                        </div>
                        <template v-if="project_type === 'process'">
                            <div class="field__wrapper">
                                <p class="field_label">Формат</p>
                                <CheckboxGroup v-model:value="project_category">
                                    <Checkbox value="Короткометражное кино">Короткометражное кино</Checkbox>
                                    <Checkbox value="Полнометражное кино">Полнометражное кино</Checkbox>
                                    <Checkbox value="Cериал">Cериал</Checkbox>
                                    <Checkbox value="Веб-сериал">Веб-сериал</Checkbox>
																</CheckboxGroup>
                            </div>
                        </template>
												<template v-if="project_type === 'complete'">

                            <div class="field__wrapper" style="padding-left: 10px; padding-right: 10px; max-width: 500px">
                                <p class="field_label">Жанр</p>
                                <CheckboxGroup v-model:value="project_zhanr">
                                    <Checkbox value="Биография">Биография</Checkbox>
                                    <Checkbox value="Боевик">Боевик</Checkbox>
                                    <Checkbox value="Вестерн">Вестерн</Checkbox>
                                    <Checkbox value="Детектив">Детектив</Checkbox>
                                    <Checkbox value="Документальное">Документальное</Checkbox>
                                    <Checkbox value="Драма">Драма</Checkbox>
                                    <Checkbox value="Детское кино">Детское кино</Checkbox>
                                    <Checkbox value="Исторический фильм">Исторический фильм</Checkbox>
                                    <Checkbox value="Комедия">Комедия</Checkbox>
                                    <Checkbox value="Мелодрама">Мелодрама</Checkbox>
                                    <Checkbox value="Мистика">Мистика</Checkbox>
                                    <Checkbox value="Музыкальный фильм">Музыкальный фильм</Checkbox>
                                    <Checkbox value="Нуар">Нуар</Checkbox>
                                    <Checkbox value="Политический фильм">Политический фильм</Checkbox>
                                    <Checkbox value="Приключенческий фильм">Приключенческий фильм</Checkbox>
                                    <Checkbox value="Сказка">Сказка</Checkbox>
                                    <Checkbox value="Трагедия">Трагедия</Checkbox>
                                    <Checkbox value="Трагикомедия">Трагикомедия</Checkbox>
                                    <Checkbox value="Триллер">Триллер</Checkbox>
                                    <Checkbox value="Фантастика">Фантастика</Checkbox>
                                    <Checkbox value="Фильм-катастрофа">Фильм-катастрофа</Checkbox>
                                    <Checkbox value="Фэнтези">Фэнтези</Checkbox>
                                </CheckboxGroup>
                            </div>
												</template>
                        <div class="search_field_wrapper">
                            <div class="control">
                                <input name="search_textfield" class="input search_textfield"
                                       type="text"
                                       placeholder="Поиск проекта" v-model="search"/>
                            </div>
<!--                            <div class="control">-->
<!--                                <input value="Поиск" type="submit" class="button search_button is-info"-->
<!--                                       @click="searchProjects">-->
<!--                            </div>-->
                        </div>
                    </div>
										<div style="margin-top: 20px;">
                        <Button class="button2" @click="searchProjects">Найти</Button>
										</div>

                </div>


                <div style="margin-top: 35px;" class="columns projects_block is-multiline">

                    <div v-for="(project, index) in projects" :key="project.id"
                         class="column project_item is-6-desktop"
                         :class="[isEven(index) ? 'project_item_2' : 'project_item_1']">
                        <div class="header_project_info">
														<div class="right_block"></div>
                        </div>
                        <div class="columns project_item_block">
                            <div class="column col1 is-narrow" style="display: block; padding-right: 0">
                                <a href="#">
                                    <ImageRender
                                            class-name="project_afisha_image"
                                            :src="getProjectAvatar(project.afisha)"
                                    ></ImageRender>
																</a>
																<template v-if="currentUserEmail === 'nigmatullina.a.h@mail.ru'">
                                    <p style="margin-top: 15px;"><a @click="deleteProject(project.id)">Удалить</a></p>
																</template>
																<template v-else>
																		<p v-if="project.projectData['to_delete']" style="margin-top: 15px;"><a @click="markProjectToDelete(project.id)" >Отозвать заявку на удаление</a></p>
																		<p v-else style="margin-top: 15px;"><a @click="markProjectToDelete(project.id)" >Подать заявку на удаление</a></p>

																</template>

                            </div>
                            <div class="column col2">
                                <div>
																		<p class="know_more"><a :href="'/project/to_expert_project/' + project.id"><strong><template v-if="project.name">{{ project.name }}</template><template v-else>Без названия</template></strong></a></p>
                                    <p class="author">{{ project.user_fio }}</p>
                                    <div class="project_logline">{{ project.logline }}</div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <Pagination
												@change="onPageChange"
												:page-size="by"
												v-if="projects"
												v-model:current="current"
												:total="total"
								></Pagination>
            </template>
        </div>
    </div>
</template>


<script setup>
// На основе ExpertProjects

import { ref, computed, watch } from 'vue';
import axios from "axios";
import {Pagination, Spin, Button, Checkbox, CheckboxGroup, Select} from 'ant-design-vue';
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";
import {Project } from "@/types/types.js"

const search = ref('');
const by = ref(30);
const isLoading = ref(false);

let project_type = ref('');
let project_category = ref([]);
let project_zhanr = ref([]);
watch(() => project_type.value, () => {
	project_category.value = [];
	project_zhanr.value = [];
})



const project_types = [
  {
		value: 'process',
		label: 'В разработке'
	},
	{
		value: 'complete',
		label: 'Готовые'
	}
];

/** @type {Project} */
let projects = ref([]);
let total = ref(0);
let current = ref(1);

async function getData() {
  isLoading.value = true;

  const response = await axios.post('/project/get_projects', null, {
    params: {
      page: current.value,
			limit: by.value,
			search: search.value,
			project_type: project_type.value,
			project_category: JSON.stringify(project_category.value),
			project_zhanr: JSON.stringify(project_zhanr.value)
    }
  })
  projects.value = response.data.projects;
	total.value = response.data.total;

  isLoading.value = false;
}

getData();


function onPageChange(pageNum, pageSize) {
	current.value = pageNum
	by.value = pageSize
	getData();
}

function searchProjects() {
	getData();
}

function getProjectAvatar(avatar) {
  return ImageService.getProjectImagePath(avatar);
}

function isEven(n) {
  return n % 2 == 0;
}

async function deleteProject(id) {
	const response = await axios.get('/project/delete_full/' + id);
	if (response.data !== 'ok') {
		alert(response.data);
	} else {
    getData();
	}
}


const currentUserEmail = computed(() => {
  return window.currentUserEmail;
})

async function markProjectToDelete(projectId) {
  console.log(projectId);
  await axios.get('/project/mark_project_to_delete/' + projectId);
  getData();
}

</script>
<style scoped>
.cabinet_page .container .content h1.header_title {
    font-weight: 600;
    font-size: 26px;
    color: #1d232d;
}

.header_project_info {
    display: flex;
    background: #e5e9ef;
    height: 50px;
    align-items: center;
    padding-left: 20px;
    padding-right: 10px;
    border-radius: 12px 12px 0 0;
    justify-content: space-between;
}

.header_project_info .favorite_button svg {
    cursor: pointer;
}

.header_project_info .favorite_button svg:hover path {
    stroke: #f69400;
}

.is_scored .header_project_info .favorite_button svg:hover path {
    stroke: #fff;
}

.is_scored .header_project_info {
    background: linear-gradient(135deg, #f7c100 0.01%, #f69400 100%);
}

.your_score {
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    color: #000;
}

.know_more {
    font-weight: 600;
    font-size: 22px;
    line-height: 120%;
    color: #1d232d;
}
.know_more a {
    font-size: 18px;
    font-family: "Roboto", sans-serif;
    font-weight: 600;
    color: #000;
}
.project_item_block .col1 {
    display: flex;
}
.project_item_block {
    position: relative;
}
.projects_block > .column {
    padding: 0;
}
.projects_block .project_item_1 {
    padding-left: 15px;
}
.projects_block .project_item_2 {
    padding-right: 15px;
}

.project_item > .columns {
    background: #f7f7f7;
    margin-bottom: 40px;
    border-top: 0;
}

.project_category {
    font-weight: 400;
    font-size: 12px;
    line-height: 118%;
    color: rgba(29, 35, 45, 0.5);
}
.columns {
    margin-left: auto;
    margin-right: auto;
}

.author {
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    color: #1d232d;
}

.project_item_block {
    margin-top: 0;
    padding: 20px;
}

.project_item_block {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}

.project_logline {
    font-weight: 400;
    font-size: 14px;
    line-height: 135%;
    color: rgba(29, 35, 45, 0.8);
    margin-top: 20px;
}

.isActiveStar {
    color: #F69F22;
}

.header_project_info .score {
    border-radius: 12px;
    background: #fff;
    padding: 7px 7px;
    font-weight: 600;
    font-size: 20px;
    line-height: 120%;
    text-align: center;
    color: #1d232d;
    min-width: 40px;
}

.is_not_scored .header_project_info .score {
    background: rgba(255, 255, 255, 0.5);
}

.ant-pagination {
    margin-left: 0;
}

.right_block {
    display: flex;
}

p {
    font-size: 16px;
}

.project_item_block:deep .project_afisha_image {
    border-radius: 12px;
    max-width: 183px;
}

.is_not_scored .favorite__wrapper svg path {
    fill: #f69400;
    stroke: #f69400;
}

.control .search_textfield {
		border-radius: 4px;
}

.ant-switch {
    height: 21px;
    min-width: 38px;
}

.project_tour_text {
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
}

.filters_block_wrapper {
    display: flex;
    justify-content: space-between;
}

.switchers__wrapper {
    display: flex;
    flex-wrap: wrap;
}

.switchers__wrapper .switch__wrapper:not(:last-child) {
    margin-right: 20px;
}

@media (max-width: 1000px) {
    .switchers__wrapper .switch__wrapper {
        margin-bottom: 15px;
    }
}

.switch__wrapper span {
    cursor: pointer;
}

.project_category_text {
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 18px;
    background: linear-gradient(135deg, #f7c100 0.01%, #f69400 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

@media (max-width: 1000px) {
    .header_title {
        font-size: 21px;
        line-height: normal;
    }

    .project_category_text {
        font-size: 16px;
    }

    .filters_block_wrapper {
        flex-wrap: wrap;
    }

    .search_field_wrapper {
        margin-top: 30px;
    }

    .project_category {
        margin-top: 20px;
    }

    .project_afisha_image {
        margin: auto;
    }
}
</style>
